import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'sleepQuality'

const ANSWER_TEXTS = {
  '1': 'Very poor',
  '2': 'Poor',
  '3': 'Average',
  '4': 'Good',
  '5': 'Excellent',
}
export default function SleepQualityPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.sleepQuality.heading', { lng: 'en' }),
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.sleepQuality.heading')}
      leftText={t('pages.onboarding.sleepQuality.options.1')}
      rightText={t('pages.onboarding.sleepQuality.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
    />
  )
}
